<template>

	<div class="circle" :title="this.debug ? 'color:red, hover:--bg-message, fileName: w3_chevron_up_white, spinning: true ' : ''"
		style="padding:0px;position:relative;">
		<img :src="src" style="height:auto;" :class="this.spinning ? 'spinner' : ''" class="circle-image">
	</div>
</template>

<script>
export default {
	name: "Circle",
	props: {
		color: {
			type: String,
			default: "orange"
		},
		hover: {
			type: String,
			default: "darkgrey"
		},
		fileName: {
			type: String,
			default: 'w3_chevron_up_white'
		},
		spinning: {
			type: Boolean,
			default: false
		},
		padding:{
			type:String,
			default: "15%"
		},
		marginTop:{
			type:String,
			default: "0px"
		},
		marginLeft: {
			type: String,
			default: "0px"
		},
		size:{
			type:String,
			default: "30px"
		},
		cursor:{
			type:String,
			default: "pointer"
		}

	},
	data() {
		return {
			//backgroundColor: "var(--bg-dark)",
			//backgroundHoverColor: "var(--bg-light)"
		}

	},

	computed: {

		backgroundHoverColor() {

			if (this.hover == null || this.hover == ""){
				return this.backgroundColor
			}

			if (this.hover.startsWith("-")) {
				return "var(" + this.hover + ")";
			} else {
				return this.hover;
			}

		},

		backgroundColor() {
			if (this.color.startsWith("-")) {
				return "var(" + this.color + ")";
			} else {
				return this.color;
			}
		},

		height(){
			return this.size;
		},
		width() {
			return this.size;
		},
		src() {
			//return require("@/assets/button_down.png");

			if (this.fileName) {
				return require('@/assets/' + this.fileName + '.png')
			}



			return null;
		}
	},

};
</script>

<style scoped>
div {
	background: v-bind("backgroundColor");

	border-radius: 100%;
	height: v-bind("height");
	width: v-bind("width");
	cursor: v-bind("cursor");
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0px;
	aspect-ratio: 1/1;

}

div img{
	padding: v-bind("padding");
	margin-top: v-bind("marginTop");
	margin-left: v-bind("marginLeft");
	overflow:auto;
}

div.size-small {
	height: 20px;
	width: 20px;
}

div:hover {
	background: v-bind("backgroundHoverColor");

	border-radius: 100%;


}
</style>
